import { storeMasterData } from "../actionTypes"

// The Store Master table's unsaved edits, keyed by store code. Persisted, so
// edits not yet saved (or whose save failed) survive a reload.
const initialState = {
    edits: {}
}

export const storeMasterReducer = (state = initialState, action) => {
    const { type, payload } = action
    switch (type) {
        case storeMasterData.MERGE:
            return { ...state, ...payload }
        default:
            return state
    }
}
